import { BaseDto } from '@/shared/dtos/base-dto';

export class temporada extends BaseDto {
    public nombre !: string;
}
